import { useTenant } from './useTenant';

/**
 * Whether the tenant has the Hik-Connect integration on: `tenant.settings.hikConnect.enabled === true` (the flag
 * TenantSettings writes and Estates reads). Anything else (no tenant yet, the tenant could not be read, no flag)
 * is off: the Hik parts of the admin fail closed. There is no per-estate-group flag; an estate group only maps to a
 * Hik access level when the tenant has it on.
 */
export const isHikEnabled = (tenant: { settings?: unknown } | null | undefined): boolean =>
  (tenant?.settings as { hikConnect?: { enabled?: unknown } } | null | undefined)?.hikConnect?.enabled === true;

export const useHikEnabled = (): boolean => {
  const { tenant } = useTenant();
  return isHikEnabled(tenant);
};
